import React, { FC } from 'react';
import { ButtonColors } from '@mts-ds/components/dist/types/components/button/enums';

import ContentFilter from '../../../../components_/Content/ContentFilter';
import FormRow from '../../../../components_/Form/FormRow';
import FormCol from '../../../../components_/Form/FormCol';
import Input from '../../../../components_/Fields/Input';
import Button from '../../../../components_/Fields/Button';

interface IProps {
  filter: any;
  onChange: any;
  onClickCreate: () => void;
  hasRightsToCreate: boolean;
}

const Filter: FC<IProps> = ({ filter, onChange, onClickCreate, hasRightsToCreate }) => {
  const { search } = filter;

  return (
    <ContentFilter>
      <FormRow justify="space-between">
        <FormCol xs={4}>
          <Input
            name="search"
            type="search"
            placeholder="Найти экипировку"
            clear
            value={search}
            onMtsChange={onChange}
          />
        </FormCol>
        {hasRightsToCreate && (
          <FormCol xs="auto">
            <Button icon="plus" color={'secondary' as ButtonColors} onClick={onClickCreate}>
              Добавить тип экипировки
            </Button>
          </FormCol>
        )}
      </FormRow>
    </ContentFilter>
  );
};

export default Filter;
